import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	actionsRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.space[8],
		justifyContent: 'space-between',
	},
	availableLeads: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.space[8],
	},
	body: {
		display: 'grid',
		flex: 1,
		fontSize: typography.fontSizes.sm,
		gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
		minHeight: 0,
		overflowY: 'auto',
		[THEME.queries.md]: {
			gridTemplateColumns: 'minmax(0, 1fr)',
		},
	},
	column: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 0,
		':first-child': {
			borderRight: `1px solid ${colors.border.light}`,
		},
		[THEME.queries.md]: {
			':first-child': {
				borderRight: 'none',
			},
		},
	},
	dayLabel: {
		paddingTop: THEME.space[8],
		width: 72,
	},
	dayRow: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: THEME.space[16],
	},
	dialogColumn: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[16],
	},
	dialogRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.space[12],
	},
	dialogSelect: {
		width: 220,
	},
	dialog: {
		boxSizing: 'border-box',
		maxHeight: `calc(100vh - ${THEME.space[48]}px)`,
		maxWidth: 'none',
		overflow: 'hidden',
		padding: 0,
		width: `min(1100px, calc(100vw - ${THEME.space[48]}px))`,
		[THEME.queries.sm]: {
			maxHeight: '100vh',
			width: '100vw',
		},
	},
	dialogClose: {
		top: THEME.space[24],
		right: THEME.space[24],
	},
	dialogHeader: {
		alignItems: 'center',
		borderBottom: `1px solid ${colors.border.light}`,
		flexDirection: 'row',
		flexWrap: 'wrap',
		margin: 0,
		padding: `${THEME.space[16]}px ${THEME.space[56]}px ${THEME.space[16]}px ${THEME.space[16]}px`,
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[4],
		minWidth: 0,
	},
	fieldGrid: {
		display: 'grid',
		gap: THEME.space[12],
		gridTemplateColumns: '1fr 1fr',
	},
	fieldWide: {
		gridColumn: '1 / span 2',
	},
	fillTrigger: {
		background: colors.background.light,
		width: '100%',
	},
	footer: {
		borderTop: `1px solid ${colors.border.light}`,
		padding: THEME.space[16],
	},
	outcomeChildren: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[12],
		paddingLeft: THEME.space[24],
	},
	outcomeGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[12],
	},
	outcomeParent: {
		fontWeight: typography.fontWeights.semibold,
	},
	outcomeList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[16],
		paddingLeft: THEME.space[24],
	},
	drawerSection: {
		borderBottom: `1px solid ${colors.border.light}`,
		padding: THEME.space[16],
	},
	sectionBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[12],
		padding: `${THEME.space[16]}px ${THEME.space[4]}px ${THEME.space[4]}px`,
	},
	sectionChevron: {
		transform: 'rotate(90deg)',
		transition: 'transform 150ms ease-out',
		':is([data-panel-open] *)': {
			transform: 'rotate(-90deg)',
		},
	},
	sectionTrigger: {
		alignItems: 'center',
		background: 'transparent',
		border: 'none',
		color: colors.text.dark,
		cursor: 'pointer',
		display: 'flex',
		fontFamily: 'inherit',
		fontSize: typography.fontSizes.lg,
		justifyContent: 'space-between',
		padding: 0,
		width: '100%',
	},
	subLabel: {
		color: colors.text.dark,
		fontSize: typography.fontSizes.sm,
		margin: 0,
	},
	radioContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[8],
		paddingLeft: THEME.space[24],
	},
	radioGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[8],
	},
	tagBuilder: {
		background: colors.background.light,
		margin: 0,
		width: 'auto',
	},
	timeSelect: {
		background: colors.background.light,
		width: 120,
	},
	toEnd: {
		marginLeft: 'auto',
	},
});
